import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const ViewVehicleList = async (bundleId, addressId, contactId, crmRefId, vehicleId, requestedvehicleId, filterDoNotShipVehicles = false) => {
  try {
    const response = await getRequest(
      urls.WT_VIEW_VEHICLE_LIST +
        `?bundleIds=${bundleId}` +
        (addressId ? `&addressId=${addressId}` : "") +
        (contactId ? `&contactId=${contactId}` : "") +
        `&crmRefId=${crmRefId}` +
        (vehicleId ? `&vehicle=${vehicleId}` : "") +
        (requestedvehicleId ? `&vehicleId=${requestedvehicleId}` : "")
    );

    // Filter out vehicles where isShippingBlocked is true
    if (response?.data?.data?.vehicles && filterDoNotShipVehicles) {
      const filteredVehicles = {};

      Object.keys(response.data.data.vehicles).forEach((bundleKey) => {
        const vehicleArray = response.data.data.vehicles[bundleKey];
        if (Array.isArray(vehicleArray)) {
          // Filter out vehicles where isShippingBlocked is true
          const filteredVehicleArray = vehicleArray.filter((vehicle) => {
            return vehicle.isShippingBlocked !== true;
          });

          // Only include the bundle if it has vehicles after filtering
          if (filteredVehicleArray.length > 0) {
            filteredVehicles[bundleKey] = filteredVehicleArray;
          }
        }
      });

      // Update the response with filtered vehicles
      response.data.data.vehicles = filteredVehicles;
    }

    return response;
  } catch (err) {
    return err;
  }
};
